import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
const defaultValues = {
    code: "",
    description: "",
};
const PermissionForm = ({ initialData, onSubmit, onCancel }) => {
    const [values, setValues] = useState(initialData
        ? {
            code: initialData.code,
            description: initialData.description ?? "",
        }
        : defaultValues);
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);
    const handleChange = (event) => {
        const { name, value } = event.target;
        setValues(prev => ({
            ...prev,
            [name]: value,
        }));
    };
    const validate = () => {
        const formErrors = {};
        if (!values.code.trim()) {
            formErrors.code = "Le code est obligatoire.";
        }
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!validate()) {
            return;
        }
        try {
            setSubmitting(true);
            await onSubmit(values);
        }
        finally {
            setSubmitting(false);
        }
    };
    return (_jsxs("div", { className: "bg-white w-full", children: [_jsx("div", { className: "flex flex-col md:flex-row justify-between items-center border-b p-4 bg-gray-100", children: _jsx("h2", { className: "text-lg font-semibold", children: initialData ? "Modifier une permission" : "Créer une permission" }) }), _jsxs("form", { onSubmit: handleSubmit, className: "flex max-w-xl flex-col gap-4 p-2", children: [_jsxs("div", { className: "flex flex-col gap-1", children: [_jsx("label", { htmlFor: "code", className: "text-sm font-medium text-gray-700", children: "Code" }), _jsx("input", { id: "code", name: "code", type: "text", value: values.code, onChange: handleChange, className: "rounded border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none", placeholder: "TASK_READ", required: true }), errors.code && _jsx("p", { className: "text-xs text-red-600", children: errors.code })] }), _jsxs("div", { className: "flex flex-col gap-1", children: [_jsx("label", { htmlFor: "description", className: "text-sm font-medium text-gray-700", children: "Description" }), _jsx("textarea", { id: "description", name: "description", value: values.description, onChange: handleChange, className: "min-h-[120px] rounded border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none", placeholder: "D\u00E9crivez ce que permet cette permission" }), _jsx("p", { className: "text-xs text-gray-500", children: "Cette description est affich\u00E9e pour aider les administrateurs \u00E0 comprendre l'objectif de la permission." })] }), _jsxs("div", { className: "mt-4 flex justify-end gap-3", children: [_jsx("button", { type: "button", onClick: onCancel, className: "rounded border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100", disabled: submitting, children: "Annuler" }), _jsx("button", { type: "submit", className: "rounded bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-70", disabled: submitting, children: initialData ? "Enregistrer" : "Créer" })] })] })] }));
};
export default PermissionForm;
